// Guest album-view invitations survive registration, email confirmation and
// login, so they live in localStorage rather than the session. This is kept
// deliberately separate from contribution claiming.
export const ALBUM_INVITATION_CONTEXT_KEY = 'everbook.sharedAlbumViewInvitation.v1';

export function storeAlbumInvitationContext(context) {
  try {
    localStorage.setItem(ALBUM_INVITATION_CONTEXT_KEY, JSON.stringify(context));
  } catch {
    // Continuing the invitation is best-effort; viewing still works.
  }
}

export function readAlbumInvitationContext() {
  try {
    const parsed = JSON.parse(localStorage.getItem(ALBUM_INVITATION_CONTEXT_KEY) || 'null');
    return parsed?.share_slug ? parsed : null;
  } catch {
    return null;
  }
}

export function clearAlbumInvitationContext() {
  try {
    localStorage.removeItem(ALBUM_INVITATION_CONTEXT_KEY);
  } catch {}
}

export function formatGuestTimeRemaining(secondsRemaining) {
  const seconds = Number(secondsRemaining);
  if (!Number.isFinite(seconds) || seconds <= 0) return 'Guest access has ended';
  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  if (hours >= 24) {
    const days = Math.floor(hours / 24);
    const remainderHours = hours % 24;
    return remainderHours
      ? `${days} day${days === 1 ? '' : 's'} ${remainderHours} hr left to view`
      : `${days} day${days === 1 ? '' : 's'} left to view`;
  }
  if (hours >= 1) return `${hours} hr ${minutes} min left to view`;
  return `${Math.max(1, minutes)} min left to view`;
}
